export function getRerenderParams () {
  const meta = document.querySelector('meta[name="form-rerender-params"]')
  if (meta && meta.getAttribute('content')) {
    return JSON.parse(meta.getAttribute('content'))
  } else {
    return null
  }
}
